import Button from '../../../components/Button';
import Modal from '../../../components/Modal';

const FinishModal = ({ isOpen, onCloseModal, submitMessage }) => {
  return (
    <Modal
      isOpen={isOpen}
      onCloseModal={onCloseModal}
      title={submitMessage.title}
      mainContentClassName="max-w-md modal-center"
    >
      <form>
        <h5 className="mb-2  text-center text-gray-600 dark:text-gray-300 m-0 text-lg w-full">
          {submitMessage.message}
        </h5>
        <Button
          onClick={onCloseModal}
          type="button"
          className="w-full mt-2 px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-primary-main border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple"
        >
          Đóng
        </Button>
      </form>
    </Modal>
  );
};

export default FinishModal;
